module.exports = __webpack_public_path__ + "img/ground-floor-house-4.74e9edb4.jpg";